export const SEARCH = 'search';
export const POI_SEARCH = 'poiSearch';
export const CATEGORY_SEARCH = 'categorySearch';
export const GEOMETRY_SEARCH = 'geometrySearch';
export const NEARBY_SEARCH = 'nearbySearch';
export const SEARCH_ALONG_ROUTE = 'searchAlongRoute';




// WEBPACK FOOTER //
// ./services/common/searchTypes.js